import React from 'react'
import { StyledRow, OuterContainer, InnerContainer } from './_styled/row.styled'

const Row = ({ children, wide, className, noPadding, ...otherProps }) => {
  const paddingArray = [
    '16px',
    '24px',
    '24px',
    wide ? '32px' : `calc(${100 / 12}% + 32px)`,
  ]

  return (
    <StyledRow className={className}>
      <OuterContainer>
        <InnerContainer px={noPadding ? 0 : paddingArray} {...otherProps}>
          {children}
        </InnerContainer>
      </OuterContainer>
    </StyledRow>
  )
}

export default Row
